import { isArray, isString, uniq } from 'lodash';

export const mapTags = (value) => {
  if (isString(value)) {
    return [value?.trim()];
  }
  if (isArray(value)) {
    return uniq(
      (value ?? [])
        .filter((tag) => isString(tag) && tag.trim().length > 0)
        .map((tag) => tag.trim()),
    );
  }
  return [];
};
